import { Component, OnDestroy, OnInit, inject, signal } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { BrowserService } from '../browser.service';
import { NAV_ITEMS } from '../nav-items';

@Component({
  selector: 'app-sticky-bar',
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './sticky-bar.component.html',
  styleUrl: './sticky-bar.component.scss',
})
export class StickyBarComponent implements OnInit, OnDestroy {
  private readonly browser = inject(BrowserService);

  readonly items = NAV_ITEMS;
  readonly visible = signal(false);

  private onScroll = (): void => {
    this.visible.set(window.scrollY > 300);
  };

  ngOnInit(): void {
    if (this.browser.isBrowser) {
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll();
    }
  }

  ngOnDestroy(): void {
    if (this.browser.isBrowser) {
      window.removeEventListener('scroll', this.onScroll);
    }
  }
}
